import Vue from 'vue'
import Vuex from 'vuex'
import {PROFILE_NAMESPACE} from './modules/profile-types'
import {TITLE_NAMESPACE} from './modules/title-types'
import {AUTH_NAMESPACE} from './modules/auth-types'
import {BURIAL_NAMESPACE} from './modules/burial-types'
import {DOCUMENTS_NAMESPACE} from './modules/documents-types'
import {CONTACTS_NAMESPACE} from './modules/contacts-types'
import {INVITATIONS_NAMESPACE} from './modules/invitations-types'
import {GUARDIANS_NAMESPACE} from './modules/guardians-types'
import {PROTEGES_NAMESPACE} from './modules/proteges-types'
import {CEREMONY_NAMESPACE} from './modules/ceremony-types'
import {PETS_NAMESPACE} from './modules/pets-types'
import {SPEECHES_NAMESPACE} from './modules/speeches-types'
import {USER_NAMESPACE} from './modules/user-types'
import {MUSIC_NAMESPACE} from './modules/music-types'
import profile from './modules/profile'
import title from './modules/title'
import auth from './modules/auth'
import burial from './modules/burial'
import documents from './modules/documents'
import contacts from './modules/contacts'
import invitations from './modules/invitations'
import guardians from './modules/guardians'
import proteges from './modules/proteges'
import ceremony from './modules/ceremony'
import pets from './modules/pets'
import speeches from './modules/speeches'
import user from './modules/user'
import music from './modules/music'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {}

const store = new Vuex.Store({
    modules: {
        [AUTH_NAMESPACE]: auth,
        [TITLE_NAMESPACE]: title,
        [PROFILE_NAMESPACE]: profile,
        [BURIAL_NAMESPACE]: burial,
        [DOCUMENTS_NAMESPACE]: documents,
        [CONTACTS_NAMESPACE]: contacts,
        [INVITATIONS_NAMESPACE]: invitations,
        [GUARDIANS_NAMESPACE]: guardians,
        [PROTEGES_NAMESPACE]: proteges,
        [CEREMONY_NAMESPACE]: ceremony,
        [PETS_NAMESPACE]: pets,
        [SPEECHES_NAMESPACE]: speeches,
        [USER_NAMESPACE]: user,
        [MUSIC_NAMESPACE]: music
    },
    state,
    strict: debug,
    plugins: debug ? [createLogger({})] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js